import { type ComponentType, lazy, type ReactNode } from "react";

const pages = import.meta.glob(["/src/surfaces/standalone/pages/**/*.tsx", "!/src/surfaces/standalone/pages/**/components/**/*.tsx"]);
const lazyComponentCache = new Map<string, React.LazyExoticComponent<any>>();

/** 按 standalone pages 根目录下的相对路径懒加载页面。 */
export function standalonePage(path: string, props?: Record<string, unknown>): ReactNode {
  const normalizedPath = path.replace(/^\/+|\/+$/g, "");
  if (!normalizedPath) {
    return null;
  }

  const filePath = `/src/surfaces/standalone/pages/${normalizedPath}.tsx`;
  const indexPath = `/src/surfaces/standalone/pages/${normalizedPath}/index.tsx`;
  const importPage = pages[filePath] ?? pages[indexPath];
  if (!importPage) {
    console.warn("Standalone page not found:", normalizedPath);
    return null;
  }

  let Page = lazyComponentCache.get(normalizedPath);
  if (!Page) {
    Page = lazy(importPage as () => Promise<{ default: ComponentType<any> }>);
    lazyComponentCache.set(normalizedPath, Page);
  }

  return <Page {...props} />;
}
